"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.UpdateType = exports.RuleType = exports.FeatureStatus = exports.FeatureFlagSdkLanguageType = exports.CustomDataScope = exports.ConsentType = void 0;
var UpdateType = exports.UpdateType = function (a) {
    return a[a.Polling = 0] = "Polling", a[a.RealTime = 1] = "RealTime", a;
  }({}),
  RuleType = exports.RuleType = function (a) {
    return a.TARGETED_DELIVERY = "TARGETED_DELIVERY", a.EXPERIMENTATION = "EXPERIMENTATION", a;
  }({}),
  FeatureFlagSdkLanguageType = exports.FeatureFlagSdkLanguageType = function (a) {
    return a.ANDROID = "ANDROID", a.SWIFT = "SWIFT", a.JAVA = "JAVA", a.CSHARP = "CSHARP", a.NODEJS = "NODEJS", a.PHP = "PHP", a.RUBY = "RUBY", a.GO = "GO", a.FLUTTER = "FLUTTER", a.REACTJS = "REACTJS", a;
  }({}),
  FeatureStatus = exports.FeatureStatus = function (a) {
    return a.ACTIVATED = "ACTIVATED", a.DEACTIVATED = "DEACTIVATED", a.SCHEDULED = "SCHEDULED", a;
  }({}),
  CustomDataScope = exports.CustomDataScope = function (a) {
    return a.Visit = "VISIT", a.Visitor = "VISITOR", a.Page = "Page", a;
  }({}),
  ConsentType = exports.ConsentType = function (a) {
    return a.Required = "REQUIRED", a.NotRequired = "NOT_REQUIRED", a;
  }({});